/**
 * Freschezza dell'autenticazione rispetto alla finestra clinica (PR-G4a).
 *
 * Modulo PURO e senza dipendenze: nessun import da Firebase, nessuno
 * stato. Vive qui e non accanto a `computeMfaTier` in `hooks/useAuth.ts`
 * per due motivi:
 *  - `useAuth` importa `security/firebase`, quindi ogni consumatore di
 *    questo predicato si tirerebbe dietro l'inizializzazione dell'app;
 *  - i test che mockano `../useAuth` per intero (es.
 *    `useMfaStepUp.test.tsx`) dovrebbero ri-dichiarare la funzione nel
 *    mock, e una parita' verificata contro la propria copia non verifica
 *    nulla.
 */

import { MFA_CLINICAL_MAX_AGE_SEC } from './constants';

/**
 * Vero se `auth_time` cade entro la finestra clinica di 4 ore, la stessa
 * che le Cloud Functions impongono con `assertMfaFresh4h`.
 *
 * NON e' derivabile da `computeMfaTier`: 4h cade DENTRO il Tier 1, quindi
 * un Tier 1 puo' essere sia fresco (2h) sia stantio (8h) rispetto a
 * questa soglia. Serve la differenza esatta, non il tier.
 *
 * - `auth_time` assente, nullo o non positivo → stantio (fail-closed).
 * - `auth_time` nel futuro (clock skew) → fresco, coerente con
 *   `computeMfaTier`, che in quel caso ritorna 2.
 */
export function isClinicalMfaFresh(
  authTimeSec: number | null | undefined,
  nowSec: number = Math.floor(Date.now() / 1000)
): boolean {
  if (!authTimeSec || authTimeSec <= 0) return false;
  return nowSec - authTimeSec <= MFA_CLINICAL_MAX_AGE_SEC;
}
